import { Component, OnInit, ViewChild, OnDestroy, NgZone } from '@angular/core';
import { StreamingService } from '../service/streaming-service';
import { AuthenticationService } from '../service/authentication.service';
import { UtilService } from '../service/util.service';
import { ApiService } from '../service/api.service';
import { Constants } from '../constants/constants';
// import { VehicleBrandService } from '../service/vehicle-brand.service';
import { ToastService } from '../service/toast.service';
// import { Services } from '@angular/core/src/view';
// import { FLAGS } from '@angular/core/src/render3/interfaces/view';
import { interval } from 'rxjs';
import { startWith, switchMap } from "rxjs/operators";
import { isNullOrUndefined } from 'util';
// import { ServicePackage, ServicePackageWithDefaultServiceRatePlan } from '../service/package-rate-plan-util.service';

@Component({
  selector: 'app-streaming',
  templateUrl: './streaming.component.html',
  styleUrls: ['./streaming.component.scss']
})
export class StreamingComponent implements OnInit, OnDestroy {

  displayServiceList;
  serviceCategoryList;
  serviceList;
  journeyData: any;
  //packageList;
  authSubscription: any;
  addPackageModal;
  selectedJourney = null;
  showViewJourneyDetail = false;
  accountData: any;
  poll: any;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private streamingService: StreamingService, private toastService: ToastService, private ngZone : NgZone) { //private packageData: PackageService, private vehicleBrandService: VehicleBrandService,
    this.authSubscription = this.authService.authenticationState.subscribe(state => {
      console.log("Auth Changed : ", state, " logged in user details : ", this.authService.loggedInUser);
      if (state) {
        this.init();
      }
    });
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      console.log("unsubscribe subscription");
      this.authSubscription.unsubscribe();
    }
    if (this.poll) {
      this.poll.unsubscribe();
    }
  }

  ngOnInit() {
  }

  init() {
    this.getStreamData();
    // this.pollingFunction();


    // this.initAddPackageModal();
  }

  getJourneyDuration(index: any) {
    //console.log("")
    var startDate = Date.parse(this.journeyData[index].startDate); //new Date(this.journeyData[index].startDate); //.getTime();
    var endDate = new Date(this.journeyData[index].endDate).getTime();
    // console.log("journey date:", startDate, "-", endDate);
    var durationinMillis = (endDate - startDate);
    var duration = (endDate - startDate) / (1000 * 60);
    // console.log("Journey duration at index:", index, "in mins:", (duration), " & in hrs:", duration/60);
    return Math.round(duration).toFixed(0);
  }



  closeOfViewClicked(data) {
    this.showViewJourneyDetail = false;
  }


  onJourneyClicked(journey: any) {
    console.log("journey clicked - ", journey);
    this.showViewJourneyDetail = true;
    this.selectedJourney = journey;
  }

  getStreamData() {
    // this.journeyData = this.streamingService.getJourneyStreamData();
    // this.calculateJourneyParameters();
    console.log("StreamData:", this.journeyData);

    /******* API call *******/
    this.utilService.showSpinner();
    this.apiService.getStreamingData().then((data) => {
      this.utilService.hideSpinner();
      console.log("streamData:", this.journeyData);
      if (!isNullOrUndefined(data) && data.length > 0) {
        this.journeyData = data;
        this.calculateJourneyParameters();
        console.log("StreamData:", this.journeyData);
      }
      this.pollingFunction();
      //this.updateSelectedServicePackage();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getStreamData();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
    /************ end api call **********/
  }

  pollingFunction() {
    this.poll = interval(5000)
      .pipe(
        startWith(0),
        switchMap(() => this.apiService.getStreamingData()) //TODO: replace getAccountDetail() with getStreamingData()
      )
      .subscribe(res => {
        if (!isNullOrUndefined(res) && res.length > 0) {

          if (isNullOrUndefined(this.journeyData)) {
            this.journeyData = res;
          } else {
            // this.ngZone.runOutsideAngular(() => {
            //   this.journeyData = res.concat(this.journeyData);
            // });
            this.ngZone.run(() =>  this.journeyData = res.concat(this.journeyData));
          }
           
          }
          console.log("streamData:", this.journeyData);
          this.calculateJourneyParameters();
          console.log("StreamData:", this.journeyData);
        
      });
    //.subscribe(res => { 
    //   this.journeyData = res; 
    //   console.log("journeyData:", this.journeyData);
    //   calculateJourneyParameters(); 
    // });
    ;
  }


  calculateJourneyParameters() {
    if (this.journeyData && this.journeyData.length > 0) {
      for (var i = 0; i < this.journeyData.length; i++) {
        this.journeyData[i]['duration'] = this.getJourneyDuration(i);
        this.journeyData[i]['mileage'] = this.calculateMileage(i);
        this.journeyData[i]['avgSpeed'] = this.calculateAvgSpeed(i);
        console.log("journey params at index :", i, " duration:", this.journeyData[i]['duration'], ", mileage:", this.journeyData[i]['mileage'],
          ", avg speed:", this.journeyData[i]['avgSpeed']);
      }
    }
  }

  calculateAvgSpeed(index: number): any {
    var journey = this.journeyData[index];
    var speed = (journey.duration > 0) ? (journey.distanceTravel.value / (journey.duration / 60)) : null;
    return speed;
  }

  calculateMileage(index: number): any {
    var journey = this.journeyData[index];
    var mileage = (journey.fuelConsumption.value > 0) ? (journey.distanceTravel.value / journey.fuelConsumption.value) : null;
    return mileage;
  }






}